import { GetStaticProps, NextPage } from "next";
import { HomePageComponent } from "../components/homePage/HomepageComponent";
import { Fetcher } from "../Fetcher";
import { HomePageFragment } from "../generated/graphcms";

interface Props {
  page: HomePageFragment;
}

export const HomePage: NextPage<Props> = ({ page }) => {
  return <HomePageComponent page={page} />;
};

export default HomePage;

export const getStaticProps: GetStaticProps<Props> = async () => {
  const res = await Fetcher.getHomePage();

  if (res.data.homePages.length < 1)
    throw new Error("No published homepage found.");

  return {
    props: {
      page: res.data.homePages[0],
    },
  };
};
